import { Grid, Typography } from '@mui/material';
import React from 'react';

type Props = {
	children: JSX.Element;
	label: string;
	// eslint-disable-next-line react/require-default-props
	'data-testid'?: string;
};

export default ({ children, label, 'data-testid': dataTestId }: Props) => (
	<>
		<Grid item xs={4} display="flex" alignItems="center">
			<Typography textTransform="capitalize" variant="body1">
				{label}
			</Typography>
		</Grid>
		<Grid item xs={8} data-testid={dataTestId}>
			{children}
		</Grid>
	</>
);
